<template>
  <div class="quesContainer">
    <!-- <div class="pb10 colorBlue b">{{ order }}. {{ answerData.qtypename }}</div> -->
    <template v-if="answerData && answerData.intro">
      <math-formula v-if="
        formatHtml(
          answerData,
          answerData.intro,
          'intro',
          answerData.qtypename
        ).includes('$')
      " :content="formatHtml(
        answerData,
        answerData.intro,
        'intro',
        answerData.qtypename
      )
        " />
      <div v-else class="quesContent" v-html="formatHtml(
        answerData,
        answerData.intro,
        'intro',
        answerData.qtypename
      )
        "></div>
    </template>
    <template v-if="answerData && answerData.question">
      <math-formula v-if="
        formatHtml(
          answerData,
          answerData.question,
          'question',
          answerData.qtypename
        ).includes('$')
      " :content="formatHtml(
        answerData,
        answerData.question,
        'question',
        answerData.qtypename
      )
        " />
      <div v-else class="quesContent" v-html="formatHtml(
        answerData,
        answerData.question,
        'question',
        answerData.qtypename
      )
        "></div>
    </template>
    <template v-if="answerData && answerData.options && !['判断题', '填空题'].includes(answerData.qtypename)">
      <math-formula v-if="
        formatHtml(answerData, answerData.options, 'options', answerData.qtypename).includes('$')" :content="formatHtml(answerData, answerData.options, 'options', answerData.qtypename)
          " />
      <div v-else class="quesContent" v-html="formatHtml(answerData, answerData.options, 'options', answerData.qtypename)
        "></div>
    </template>
    <template v-if="answerData && answerData.dispAnswer">
      <div class="pt20 pb10 colorBlue b">[正确答案]</div>
      <math-formula v-if="
        formatHtml(
          answerData,
          answerData.dispAnswer,
          'dispAnswer',
          answerData.qtypename
        ).includes('$')
      " :content="formatHtml(
        answerData,
        answerData.dispAnswer,
        'dispAnswer',
        answerData.qtypename
      )
        " />
      <div v-else class="quesContent" v-html="formatHtml(
        answerData,
        answerData.dispAnswer,
        'dispAnswer',
        answerData.qtypename
      )">
      </div>
    </template>
    <template v-if="answerData && answerData.analyse">
      <div class="pt20 pb10 colorBlue b">[答案解析]</div>
      <math-formula v-if="
        formatHtml(
          answerData,
          answerData.analyse,
          'analyse',
          answerData.qtypename
        ).includes('$')
      " :content="formatHtml(
        answerData,
        answerData.analyse,
        'analyse',
        answerData.qtypename
      )
        " />
      <div v-else class="quesContent" v-html="formatHtml(
        answerData,
        answerData.analyse,
        'analyse',
        answerData.qtypename
      )">
      </div>
    </template>
    <template v-if="answerData && answerData.childQuestions && answerData.childQuestions.length > 0">
      <div v-for="(item2, index2) in answerData.childQuestions" :key="item2.questionId">
        <math-formula v-if="
          formatHtml(item2, item2.question, 'question1', item2.qtypename).includes('$')"
          :content="formatHtml(item2, item2.question, 'question1', item2.qtypename)" />
        <div v-else class="quesContent" v-html="formatHtml(item2, item2.question, 'question1', item2.qtypename)"></div>
        <template v-if="item2.options && !['判断题', '填空题'].includes(item2.qtypename)">
          <math-formula v-if="
            formatHtml(item2, item2.options, 'options', item2.qtypename).includes('$')"
            :content="formatHtml(item2, item2.options, 'options', item2.qtypename)" />
          <div v-else class="quesContent" v-html="formatHtml(item2, item2.options, 'options', item2.qtypename)">
          </div>
        </template>

        <template v-if="item2.dispAnswer || item2.answer">
          <div class="pt20 pb10 colorBlue b">[正确答案]</div>
          <math-formula v-if="
            formatHtml(item2, item2.dispAnswer || item2.answer, 'dispAnswer', item2.qtypename).includes('$')"
            :content="formatHtml(item2, item2.dispAnswer || item2.answer, 'dispAnswer', item2.qtypename)" />
          <div v-else class="quesContent"
            v-html="formatHtml(item2, item2.dispAnswer || item2.answer, 'dispAnswer', item2.qtypename)">
          </div>
        </template>
        <template v-if="item2.analyse">
          <div class="pt20 pb10 colorBlue b">[答案解析]</div>
          <math-formula v-if="
            formatHtml(item2, item2.analyse, 'analyse', item2.qtypename).includes('$')"
            :content="formatHtml(item2, item2.analyse, 'analyse', item2.qtypename)" />
          <div class="quesContent" v-html="formatHtml(item2, item2.analyse, 'analyse', item2.qtypename)">
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import MathFormula from './MathFormula.vue'
import { removeLeadingIndex } from '@/utils/tools'
export default {
  components: { MathFormula },
  props: {
    answerData: {
      type: Object,
      default: () => null
    },
    order: {
      type: Number,
      default: 1
    }
  },
  emits: [], // 声明自定义事件
  data() {
    return {
      encryKey:
        'noahonlinepingcenoah诺亚教育网(www.noahedu.com)在线视频2013-11-26'
    }
  },
  methods: {
    formatHtml(obj, str, type, qtypename = '') {
      str = str.replace(/<sound[^>]*>([\s\S]*?)<\/sound>/g, '')
      str = str.replace(/\n[ \u3000]+/g, '\n')
      if (type === 'answer') {
        return this.formatAnswer(str, qtypename)
      } else if (type === 'options') {
        return this.formatOption(str, qtypename)
      } else if (type === 'question') {
        return this.formatQuestion(obj, str, qtypename)
      } else if (type === 'question1') {
        return this.formatQuestion(obj, str, qtypename)
      } else if (type === 'intro') {
        return this.formatContent(str, qtypename)
      } else {
        return this.formatContent(str, qtypename)
      }
    },
    formatQuestion(obj, question, qtypename) {
      const id = obj.id || ''
      const typeId = obj.type || ''
      question = this.formatContent(question, qtypename)
      if (
        qtypename === '一对一连线题' ||
        qtypename === '一对多连线题' ||
        (!id && [32, 33, 6].includes(typeId)) ||
        (id && [6, 7].includes(typeId))
      ) {

        question = question.replace(/\n/g, '<br>')
        question = question.replace(/&&&&/g, '</li><li>')
        question = question.replace(/&&<br>&&/g, '</li></ul><ul><li>')
        question = question.replace(/<br>&&/g, '</li></ul><ul><li>')
        question = question.replace(/&&$/g, '</li></ul>')
        question = question.replace(/&&/g, '')
        question = `<div class="line2line"><ul><li>${question}</li></ul></div>`
      }
      if (
        qtypename === '连词成句' ||
        (!id && [49].includes(typeId)) ||
        (id && [12, 13].includes(typeId))
      ) {
        question = question.replace(/\s/g, '')
        question = question.replace(/&&&&/g, '</span><span class="wordSpan">')
        question = question.replace(/&&<br>/g, '</span>')
        question = question.replace(/&&/g, '<span class="wordSpan">')
      }
      if (
        qtypename === '田字格' ||
        (!id && [18].includes(typeId)) ||
        (id && [11].includes(typeId))
      ) {
        question = question.replace(/<span class="answerArea"><\/span>/g, ' ')
        // eslint-disable-next-line no-control-regex
        question = question.replace(/\u000E\u0003/g, '<田字格>')
        question = question.replace(/\s+/g, ' ')
        var pyArr = question.match(/<田字格>([^<]+)<田字格>/g)
        if (pyArr && pyArr.length > 0) {
          pyArr.forEach((item8, index8) => {
            var oldStr = item8.replace(/<田字格>/g, '')
            var newStr = oldStr.replace(/\s/g, '')
            var strArr = ''
            var strHtml = ''
            if (/^[\u4E00-\u9FA5]+$/g.test(newStr)) {
              // 中文
              strArr = oldStr.split('')
              strArr.forEach((item9, index9) => {
                strHtml += `<div class="tzg"><i></i><span>${item9}</span></div>`
              })
              question = question.replace(item8, strHtml)
            } else {
              // 拼音
              strArr = oldStr.replace(/\s$/g, '').split(' ')
              strArr.forEach((item9, index9) => {
                strHtml += `<div class="tzg"><i>${item9}</i><span></span></div>`
              })
              question = question.replace(item8, strHtml)
            }
          })
        }
      }
      if (qtypename === '排序题' || typeId === 48) {
        question = question.replace(/^&&|&&$/g, '').replace(/\s/g, ' ')
        var quesArr = question.split('&&&&')
        var quesHtml = ''
        quesArr.forEach(function (item5, index5) {
          quesHtml += `${index5 + 1}.${item5}<br>`
        })
        question = quesHtml
      }

      return this.formatContent(question, qtypename)
    },
    formatContent(content, qtypename) {
      var newContent = content || ''
      if (!newContent) {
        return ''
      }
      newContent = newContent.replace(/<\/?作者>/g, '')
      newContent = newContent
        .replace(/<标题>/g, '<div class="textCenter b">')
        .replace(/<\/标题>/g, '</div>')
      newContent = newContent.replace(/<竖排>\n/g, '')
      // eslint-disable-next-line prettier/prettier
      newContent = newContent.replace(/[’]/g, '\'')
      newContent = newContent.replace(/<(\/?)生词>/g, '<$1b>')
      // eslint-disable-next-line no-control-regex
      newContent = newContent.replace(/\u000BD\u000BD、/g, '、\u000BD\u000BD')
      // eslint-disable-next-line no-control-regex
      newContent = newContent.replace(/\u000BD\u000BD/g, '')
      // eslint-disable-next-line no-control-regex
      newContent = newContent.replace(/\u000BD(.*?)\u000BD/g, '<rt>$1</rt>')
      // eslint-disable-next-line no-control-regex
      newContent = newContent.replace(/\u000BD/g, '<拼音>')
      newContent = newContent.replace(
        /<拼音>([^<]+)<拼音>|<\/?sound[^>]*>/g,
        ''
      )
      newContent = newContent.replace(
        /http:\/\/imgs.cloud.noahedu.com/g,
        'https://szimgs.youxuepai.com'
      )
      // if (newContent.indexOf('&&') !== -1) {
      //   newContent = newContent.replace(/}}&&&&{{/g, '}}</li><li>{{')
      //     .replace(/}}&&\n&&{{/g, '}}</li></ul><ul class="line2Line"><li>{{')
      //     .replace(/&&{{/g, '<div class="lineBox"><ul class="line2Line"><li>{{')
      //     .replace(/}}&&/g, '}}</li></ul></div>')
      // }
      var dotArr = newContent.match(/<udot>([^<]+)<\/udot>/g)
      if (dotArr && dotArr.length > 0) {
        dotArr.forEach((item, index) => {
          var newArr = item.replace(/<\/?udot>/g, '').split('')
          newArr.forEach((item2, index2) => {
            newArr[index2] = `<udot>${item2}</udot>`
          })
          var newStr = newArr.join('')
          newContent = newContent.replace(item, newStr)
        })
      }

      // if (newContent.indexOf('<audio') !== -1) {
      //   newContent = newContent.replace(/<audio/g, '<audio controls width="100%" height="60"')
      // }
      // if (newContent.indexOf('<orig') !== -1) {
      //   newContent = newContent.replace(/<\/orig>/g, '').replace(/<orig\ssrc="([^"]*)"\s?\/?>/g, '听力原文: $1')
      // }

      if (newContent.indexOf('<拼音汉字>') !== -1) {
        newContent = newContent.replace(/<py>/g, '{').replace(/<\/py>/g, '}')
        var pyArr = newContent.match(/<拼音汉字>([^<]+)<\/拼音汉字>/g)
        if (pyArr && pyArr.length > 0) {
          var charArr = [
            ',',
            '，',
            '.',
            '。',
            '（',
            '）',
            '(',
            ')',
            '?',
            '？',
            '《',
            '<',
            '》',
            '>',
            ';',
            '；',
            '：',
            ':',
            '"',
            '“',
            '”',
            '‘',
            '’',
            '【',
            '】',
            '[',
            ']',
            '{',
            '}'
          ]
          pyArr.forEach((item, index) => {
            var hzArr = item.replace(/<\/?拼音汉字>|{([^}]+)}/g, '').split('')
            var pyArr = item.match(/{([^}]+)}/g)
            if (pyArr && pyArr.length > 0) {
              pyArr = pyArr[0].replace(/{|}/g, '').split(' ')
            }
            var html = ''
            var step = 0
            hzArr.forEach((item2, index2) => {
              if (charArr.includes(item2)) {
                step += 1
                html += `<div class="pinyinhz"><label></label><span>${item2}</span></div>`
              } else {
                html += `<div class="pinyinhz"><label>${pyArr[index2 - step]
                  }</label><span>${item2}</span></div>`
              }
            })
            newContent = newContent.replace(item, html)
          })
        }
      }

      /*
    \u000E\u0001\u000E\u0001 所在的位置为选择区域。
    \u000E\u0003\u000E\u0003 所在的位置为填空区域。
    \u000E\u0006\u000E\u0006 <方框填写区域></方框填写区域>
    \u000E\u0007\u000E\u0007 <圆形填写区域></圆形填写区域>
    \u000E\u0005\u000E\u0005 所在的位置为下划线选择区域（需要置换成下划线）。
    同一个位置有多个答案都是正确的情况，每个答案用\u0004分隔。
    \u000E\u0004括起里表示题号。
    多个区域的答案之间以\u0005区分。
    多个知识点名称之间用\u0006分隔。
    当答案顺序不固定，那么每项间用\u000B分隔。
    */
      newContent = newContent
        .replace(
          // eslint-disable-next-line no-control-regex
          /[(（]\s*\u000E\u0001\u000E\u0001\s*[)）]/g,
          '(<span class="emptyArea"></span>)'
        )
        .replace(
          // eslint-disable-next-line no-control-regex
          /[(（]\s*\u000E\u0003\u000E\u0003\s*[)）]/g,
          '(<span class="emptyArea"></span>)'
        )
        // .replace(/\n\u000E\u0003\u000E\u0003/g, '\n<span class="answerArea answerAreaFull"></span>')
        .replace(
          // eslint-disable-next-line no-control-regex
          /\u000E\u0003\u000E\u0003|\u000E\u0001\u000E\u0001/g,
          '<span class="answerArea"></span>'
        )
        .replace(
          // eslint-disable-next-line no-control-regex
          /\u000E\u0005\u000E\u0005/g,
          '(<span class="emptyArea"></span>)'
        )
        .replace(
          // eslint-disable-next-line no-control-regex
          /\u000E\u0006\u000E\u0006|\u000E\u000B\u000E\u000B/g,
          '<span class="squreBox"></span>'
        )
        .replace(
          // eslint-disable-next-line no-control-regex
          /\u000E\u0007\u000E\u0007|\u000E\u000F\u000E\u000F/g,
          '<span class="circleBox"></span>'
        )
        .replace(
          // eslint-disable-next-line no-control-regex
          /\u000E\u0004|<PushVideo>([^<]+)<\/PushVideo>|<div\salign="center">\n<\/div>|<\/?重点>|\[00:00.00\]|<原文>|<\/原文>/g,
          ''
        )
        .replace(/\n/g, '<br>')
        .replace(/○/g, '<span class="circleArea">○</span>')
        .replace(/△/g, '<span class="sanjiaoArea">△</span>')
        .replace(/□/g, '<span class="sijiaoArea">□</span>')
        .replace(/☆/g, '<span class="wujiaoArea">☆</span>')
        // .replace(/\s{3,}/g, '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        // .replace(/\s{10,}/g, '<span class="emptyArea3"></span>')
        // .replace(/\s{7,9}/g, '<span class="emptyArea2"></span>')
        // .replace(/\(\s\s\s\)/g, '(<span class="emptyArea"></span>)')
        // .replace(/\s{3}/g, '<span class="emptyArea"></span>')
        .replace(/<udot>/g, '<span class="udot">')
        .replace(/<uwavy>/g, '<span class="uwavy">')
        .replace(/<\/udot>|<\/uwavy>/g, '</span>')
        .replace(/\u0005/g, '；')
        .replace(/\u0004/g, ' ')

      const arr = newContent.match(/{{([^}]+)}}/g)
      if (arr && arr.length > 0) {
        arr.forEach((item, index) => {
          if (item.indexOf('-') === 2) {
            newContent = newContent.replace(
              item,
              `<img src="${this.decryptText(
                item.replace(/{{|}}/g, '')
              )}" style="vertical-align:middle;max-width:100%;">`
            )
          }
        })
      }
      if (
        newContent.indexOf('<rt>') !== -1 &&
        newContent.indexOf('<ruby>') === -1
      ) {
        newContent = newContent.replace(/<\/rt>/g, '</rt></ruby>')
        newContent = newContent.replace(
          /([\u4E00-\u9FA5]{1})<rt>/g,
          '<ruby>$1<rt>'
        )
      }
      newContent = newContent.replace(/<\/?latex>/g, '$')
      newContent = newContent.replace(
        /<audio/g,
        '<audio controls controlsList="nodownload" '
      )
      return newContent
    },
    decryptText(source) {
      const urlArr = source.split('a')
      const urlLen = urlArr.length
      const keyArr = this.encryKey.split('')
      const keyLen = keyArr.length
      let result = ''
      for (let i = 0; i < urlLen; i++) {
        const r = i % keyLen
        const s = parseInt(urlArr[i])
        const ss = this.encryKey.charAt(r).charCodeAt()
        const w = s - ss * i + ss * urlLen
        result += String.fromCharCode(w)
      }
      if (result.indexOf('onlinelibres1') !== -1) {
        result = result.replace(/http:/g, 'https:')
      }
      return result
    },
    formatAnswer(str) {
      if (!str) {
        return ''
      }
      return str.replace(/<\/?font([^>]*)>/g, '')
    },
    formatOption(content, qtypename) {
      var newContent = content || ''
      if (!newContent) {
        return ''
      }
      if (newContent) {
        if (
          newContent.indexOf('%%') !== -1 &&
          newContent.indexOf('\n') === -1
        ) {
          newContent = newContent.replace(/%%([^%]+)%%/g, '\n%%$1%%')
          newContent = newContent.replace(/^\n/g, '')
        }
        newContent = newContent.replace(/%%/g, '').replace(/\n+/g, '\n')
        newContent = newContent.split('\n').filter((d) => {
          return d
        })
        if (qtypename.indexOf('点选题') !== -1) {
          newContent = newContent.map((d, i) => {
            return `${String.fromCharCode(i + 65)}. ${d}`
          })
        }
        var _w = 100 / newContent.length
        var w = 0
        if (newContent.join().indexOf('<img') === -1) {
          for (var i = 0, len = newContent.length; i < len; i++) {
            w += newContent[i].length * 22
            if (w > 775) {
              _w = 100 / (i === 0 ? 1 : i)
              break
            }
          }
        }
        newContent = `<ul class="optionList"><li>${newContent.join(
          '</li><li>'
        )}</li></ul>`
        newContent = this.formatContent(newContent)
      }
      return newContent
    }
  }
}
</script>

<style scoped lang="scss">
.quesContainer {
  background-color: #fff;
  padding: 10px;

  // scoped 必须加 /deep/ 穿透
  /deep/ audio::-webkit-media-controls-download-button,
  /deep/ audio::-internal-media-controls-download-button {
    display: none !important;
  }

  .quesContent {
    position: relative;

    /deep/ img {
      max-width: 100%;
    }
  }

  .difficultBox {
    margin: 15px 0 0 0;
    padding: 10px 0 0 0;
    border-top: 1px solid #e0e0e0;
  }
}

/* 样式 */
::v-deep {

  ul,
  li {
    list-style: none;
  }

  .line2line {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    max-width: 66%;
  }

  .line2line>ul {
    min-width: 100px;
    max-width: 46%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .line2line>ul>li {
    padding: 4px 5px;
    border: 1px solid #000;
    margin: 3px 0;
    border-radius: 5px;
    text-align: center;
    vertical-align: middle;
    page-break-inside: avoid;
  }

  .line2line>ul>li>img {
    max-width: 98%;
    max-height: 100px;
  }

  .word2line {
    position: relative;
  }

  .word2line>ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .word2line>ul>li {
    padding: 4px 5px;
    border: 1px solid #000;
    margin: 3px 10px;
    border-radius: 5px;
    text-align: center;
    /* flex: 1; */
    page-break-inside: avoid;
  }

  .word2line>ul>li>img {
    max-width: 98%;
    max-height: 100px;
  }

  .containerV {
    .line2line {
      max-width: 100%;
    }
  }

  .optionLi {
    border: 1px solid #000;
    border-radius: 5px;
    display: inline-block;
    padding: 5px 15px;
    margin: 0 10px 0 0;
  }

  .optionLi>img {
    display: block;
    margin: 0 auto !important;
  }

  .tianzige {
    position: relative;
  }

  .tianzige>li {
    display: inline-block;
    margin-right: 20px;
  }

  .tzg {
    display: inline-block;
    margin: 0 2px;
    vertical-align: text-bottom;
  }

  .tzg>i {
    display: block;
    text-align: center;
    padding: 10px 0 3px;
    height: 30px;
    font-size: 16px;
  }

  .tzg>span {
    position: relative;
    display: block;
    text-align: center;
    width: 51px;
    height: 51px;
    line-height: 51px;
    border: 1px solid #000;
    /* background: url(../images/bg_box.png) no-repeat center center;  background-size: 100%;*/
  }

  .tzg>span::before {
    position: absolute;
    left: 0;
    top: 0;
    content: '';
    width: 25px;
    height: 51px;
    border-right: 1px dashed #999;
  }

  .tzg>span::after {
    position: absolute;
    left: 0;
    top: 0;
    content: '';
    width: 51px;
    height: 25px;
    border-bottom: 1px dashed #999;
  }

  .lineBox {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .lineBox>ul {
    width: 40%;
  }

  .lineBox>ul>li {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    padding: 5px 0;
    margin: 15px 0;
    border: 1px solid #e0e0e0;
  }

  .lineBox>ul>li img {
    max-width: 80%;
    max-height: 60px;
  }

  ruby {
    font-size: 16px;
    padding: 0 5px;
  }

  rt {
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0px;
    /* text-align: right; */
  }

  .pinyinhz {
    display: inline-block;
    text-align: center;
    padding: 0 10px;
  }

  .pinyinhz label {
    display: block;
  }

  .pinyinhz span {
    display: block;
  }

  .emptyArea {
    padding: 0 5px;
  }

  .emptyArea2 {
    padding: 0 35px;
  }

  .emptyArea3 {
    padding: 0 150px;
  }

  .answerArea {
    display: inline-block;
    padding: 0 25px;
    border-bottom: 1px solid #404040;
    vertical-align: text-bottom;
  }

  .answerAreaFull {
    width: 80%;
    display: inline-block;
  }

  .squreBox {
    display: inline-block;
    border: 1px solid #000;
    width: 24px;
    height: 24px;
    vertical-align: middle;
    margin: 0 2px;
  }

  .circleBox {
    display: inline-block;
    border: 1px solid #000;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    vertical-align: middle;
    margin: 0 2px;
  }

  .wordSpan {
    display: inline-block;
    padding: 5px 10px;
    border: 1px solid #000;
    border-radius: 6px;
    margin: 0 10px 10px;
  }

  .udot {
    position: relative;
    display: inline-block;
  }

  .udot::after {
    position: absolute;
    content: '';
    left: 50%;
    bottom: -1px;
    transform: translateX(-50%);
    width: 5px;
    height: 5px;
    background-color: #000;
    border-radius: 50%;
  }

  .uwavy {
    text-decoration: underline wavy #000;
  }

  .sanjiaoArea {
    font-size: 26px;
    vertical-align: middle;
    margin: 0 3px;
    line-height: 21px;
  }

  .sijiaoArea {
    font-size: 26px;
    vertical-align: top;
    margin: 0 3px;
    line-height: 21px;
  }

  .wujiaoArea {
    font-size: 26px;
    vertical-align: middle;
    margin: 0 3px;
    line-height: 21px;
  }

  .circleArea {
    font-size: 24px;
    vertical-align: top;
    margin: 0 2px;
    line-height: 22px;
  }
}
</style>
